import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Add this
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth'; // Assuming you have this; see below if not


export default function ServicesTable() {
  const [services, setServices] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth(); // Get auth status
  const navigate = useNavigate(); // For redirection

  useEffect(() => {
    const apiUrl =
      process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_API_LOCAL
        : process.env.REACT_APP_API;

    axiosPrivate
      .get(`${apiUrl}/services`)
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => {
        console.error('Error fetching services:', error);
      });
  }, []);

  const handleCardClick = (service) => {
    if (auth?.token) { // Or auth?.user — adjust based on your auth object
      // Logged in: Go to schedule, passing service ID
      navigate(`/schedule`, { state: { serviceId: service.serviceId } });
    } else {
      // Not logged in: Go to login, perhaps with redirect back
      navigate('/login', { state: { from: `/schedule`, serviceId: service.serviceId } });
    }
  };

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 xl:pl-32 xl:pr-32">
        {services.length === 0 ? (
          <p className="text-zinc-50 col-span-full">Nemoguća komunikacija sa serverom.</p>
        ) : (
          services.map((service) => (
            <div
              key={service._id} // Use unique ID, not index
              className="bg-zinc-800 text-white p-4 sm:p-3 w-full h-24 sm:h-36 md:h-36 rounded-lg shadow-md flex justify-between items-center cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-zinc-700" // Add cursor-pointer
              onClick={() => handleCardClick(service)}
              role="button" // For accessibility
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleCardClick(service); }} // Keyboard support
            >
              <h3 className="font-semibold text-xl sm:text-base md:text-xl lg:text-2xl xl:text-3xl mr-2 overflow-hidden text-ellipsis whitespace-nowrap md:whitespace-normal md:overflow-visible md:break-words flex-1 min-w-0">{service.serviceName}</h3>
              <p className="whitespace-nowrap text-xl sm:text-base md:text-xl lg:text-2xl xl:text-3xl flex-shrink-0">{service.servicePrice} RSD</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}